/**
 * 領収書関連の顧客向け文言。
 *
 * 出典: HomeDoctor 領収書発行仕様変更（2026-08-15、内部進捗定例 課題表 381 番）
 * - P6: 支払方法選択画面・支払方法変更画面の両方に同一の説明を表示する
 * - P7: 請求書払い・NP後払いの支払確認画面に問い合わせ先を表示する
 *
 * ドクター側（home_doctor_front）と文言を揃える必要があるため、変更時は両リポジトリを更新すること。
 */

/** 見出し（全画面共通） */
export const RECEIPT_NOTICE_HEADING = '領収書について';

/** 支払方法選択・変更画面の説明（PDF P6） */
export const RECEIPT_NOTICE_SELECT_LINES: readonly string[] = [
  'クレジットカード・現金払いは、お支払い完了後に領収書を発行できます。',
  '請求書払い・後払いの領収書は、ご利用の事業者へお問い合わせください。',
];

/** 請求書払い・NP後払いの支払確認画面の追加表示（PDF P7） */
export const RECEIPT_NOTICE_CONTACT_LINES: readonly string[] = [
  'ご利用の事業者へお問い合わせください。',
];

/** 領収書発行画面（クレカ・現金の支払完了後）の文言。ドクター側 PAYMENT_LABELS と揃える */
export const RECEIPT_ISSUE_TEXTS = {
  TITLE: '領収書の発行',
  DESCRIPTION:
    'お支払いが完了しました。領収書が必要な場合は宛名を入力して「領収書を発行する」を押してください。',
  /** ドクター側 PAYMENT_LABELS.RECEIPT_ADDRESS_FULL_LABEL と同文を、モバイル幅向けにラベルと注記の 2 行に分ける */
  ADDRESS_LABEL: '領収書宛先記入欄',
  ADDRESS_NOTE: '※領収書が必要なお客様は、宛名を入力してください',
  ADDRESS_PLACEHOLDER: '例：山田 太郎',
  SUBMIT: '領収書を発行する',
  SUBMITTING: '発行中...',
  SKIP: '領収書は不要（アンケートへ進む）',
  ISSUED_TITLE: '領収書を発行しました',
  ISSUED_DESCRIPTION: '領収書はお問い合わせ詳細の書類一覧からもご確認いただけます。',
  VIEW: '領収書を表示する',
  PROCEED: 'アンケートへ進む',
  ERROR: '領収書の発行に失敗しました。もう一度お試しください。',
  /** 支払情報の取得に失敗（CashPaymentConfirm と同文） */
  LOAD_ERROR: '決済情報の取得に失敗しました。',
  /** PDF ビューアのタイトル */
  PDF_TITLE: '領収書',
} as const;
